module.exports = __webpack_public_path__ + "img/SKMJ_place12.4f58f065.jpg";